// extracted by mini-css-extract-plugin
export default {"swiper-navigation":"Navigation_swiper-navigation__lS4qT"};